var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.13 12.73l-.006.057c-1.65-.822-1.822-.932-2.035-.612-.148.22-.579.723-.708.871-.132.146-.262.158-.485.056-.225-.112-.947-.348-1.802-1.113-.666-.597-1.113-1.328-1.245-1.553-.22-.38.24-.433.659-1.225.075-.158.036-.282-.02-.393-.056-.113-.503-1.215-.69-1.655-.18-.438-.366-.382-.505-.382-.432-.038-.747-.032-1.026.258-1.21 1.33-.905 2.703.13 4.162 2.036 2.664 3.12 3.155 5.104 3.836.535.17 1.024.146 1.41.09.43-.068 1.325-.54 1.512-1.07.191-.528.191-.967.135-1.068-.056-.101-.203-.157-.428-.259z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.39 4.587C12.623-.988 3.08 3.056 3.076 10.92c0 1.572.411 3.105 1.196 4.459L3 20l4.751-1.239c5.929 3.203 13.246-1.05 13.249-7.837 0-2.382-.93-4.623-2.621-6.308l.011-.029zm1.111 6.313c-.004 5.724-6.288 9.3-11.259 6.378l-.27-.16-2.812.73.754-2.733-.18-.282c-3.092-4.923.461-11.358 6.32-11.358a7.4 7.4 0 015.266 2.182A7.341 7.341 0 0119.5 10.9z",
    fill: "#fff"
  })));
}

export default SvgWhatsapp;